export default __webpack_public_path__ + "static/media/WorkSans-Regular.b13bc1b6.ttf";